export default class ValidationError extends Error {
    constructor(errors) {
        super(errors.map(error => `${error.path}:${error.type}`).join(','))
        this.errors = errors
    }
}
